import { combineReducers } from 'redux';
import Auftraege from './auftrag';
import Stammdaten from './stammdaten';
import Notifications from './notifications';
import Routing from './routing';
import Auftragserfassung from './auftragserfassung';
import Adressen from './adresse';
import Adresserfassung from './adresserfassung';
import Auth from './login';
import Benutzer from './benutzer';
import Benutzererfassung from './benutzererfassung';
import UserSession from './user-session';
import Modal from './modal';
import Translation from './translation';
import Registrierung from './register';
import Maut from './maut';
import Loading from './loading';
import Auftragsvorlagen from './auftragsvorlage';
import Admin from './admin';
import Auftragsvorlageerfassung from './auftragsvorlageerfassung';
import Config from './config';
import Initialization from './initialization';

export default combineReducers({
  Admin,
  Adressen,
  Adresserfassung,
  Auftraege,
  Auftragserfassung,
  Auftragsvorlageerfassung,
  Auftragsvorlagen,
  Auth,
  Benutzer,
  Benutzererfassung,
  Config,
  Initialization,
  Loading,
  Maut,
  Modal,
  Notifications,
  Registrierung,
  Routing,
  Stammdaten,
  Translation,
  UserSession,
});
